import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Global Payroll (/payroll-global) ──────────────────────────────────────
export const payrollGlobalApi = {
  listLocalizations: () => api.get('/payroll-global/localizations').then(unwrap),

  // jurisdictions + statutory rules
  listJurisdictions: (params) => api.get('/payroll-global/jurisdictions', { params }).then(unwrap),
  createJurisdiction: (payload) => api.post('/payroll-global/jurisdictions', payload).then(unwrap),
  listStatutoryRules: (params) => api.get('/payroll-global/statutory-rules', { params }).then(unwrap),
  createStatutoryRule: (payload) => api.post('/payroll-global/statutory-rules', payload).then(unwrap),

  // pay groups + calendars
  listPayGroups: (params) => api.get('/payroll-global/pay-groups', { params }).then(unwrap),
  createPayGroup: (payload) => api.post('/payroll-global/pay-groups', payload).then(unwrap),
  listPayCalendars: (params) => api.get('/payroll-global/pay-calendars', { params }).then(unwrap),
  createPayCalendar: (payload) => api.post('/payroll-global/pay-calendars', payload).then(unwrap),

  // components + assignments
  listComponents: (params) => api.get('/payroll-global/components', { params }).then(unwrap),
  createComponent: (payload) => api.post('/payroll-global/components', payload).then(unwrap),
  listAssignments: (params) => api.get('/payroll-global/assignments', { params }).then(unwrap),
  createAssignment: (payload) => api.post('/payroll-global/assignments', payload).then(unwrap),

  // runs
  listRuns: (params) => api.get('/payroll-global/runs', { params }).then(unwrap),
  getRun: (id) => api.get(`/payroll-global/runs/${id}`).then(unwrap),
  createRun: (payload) => api.post('/payroll-global/runs', payload).then(unwrap),
  calculateRun: (id) => api.post(`/payroll-global/runs/${id}/calculate`).then(unwrap),
  approveRun: (id, payload) => api.post(`/payroll-global/runs/${id}/approve`, payload || {}).then(unwrap),
  postRun: (id, payload) => api.post(`/payroll-global/runs/${id}/post`, payload || {}).then(unwrap),
  payRun: (id, payload) => api.post(`/payroll-global/runs/${id}/pay`, payload || {}).then(unwrap),
  listResults: (id) => api.get(`/payroll-global/runs/${id}/results`).then(unwrap),
  generatePayslip: (resultId) => api.post(`/payroll-global/results/${resultId}/payslip`).then(unwrap),
};

// Format integer cents to a currency-tagged string for display.
export function formatCents(cents, currency = '') {
  const n = Number(cents || 0) / 100;
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();
}
